import Header from "../../components/Header";
import { Outlet } from "react-router-dom";
import "../styles/public.css";

export default function PublicLayout() {
  return (
    <>
      <Header />

      <main className="public-content">
        <Outlet />
      </main>

      <footer className="public-footer">
        © Elvara Signatures
      </footer>
    </>
  );
}